<template>
  <div class="cont-h5" ref="contH5">
    <div class="swoper-box">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide>
          <div class="lb lb4">
            <div class="text">
              <div class="t1">自助收银</div>
              <div class="t2">解决门店用人难题，降低成本，提高收银效率</div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="lb lb2">
            <div class="text">
              <div class="t1">丰派云POS</div>
              <div class="t2">数字零售平台，聚合多方外部平台，</div>
              <div class="t2">多端全场景快速收银，提升门店容纳量。</div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="lb lb1">
            <div class="text">
              <div class="t1">订货商城</div>
              <div class="t2">“数字化落地+数字供应平台”为底座</div>
              <div class="t2">提供SaaS全场景供应链解决方案</div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="lb lb3">
            <div class="text">
              <div class="t1">智慧零售</div>
              <div class="t2">DIY装饰、千店千面、丰富的营销活动、</div>
              <div class="t2">会员人群管理、BI分析等，促进私域增长。</div>
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="case-box">
      <div class="title-box">
        <div class="title-iteme">
          <img v-lazy="require('@/assets/ksbs.png')" class="img" alt="" />
          <span class="col-span-1">快速部署</span>
        </div>
        <div class="title-iteme">
          <img v-lazy="require('@/assets/sjaq.png')" class="img" alt="" />
          <span class="col-span-1">数据安全</span>
        </div>
        <div class="title-iteme">
          <img v-lazy="require('@/assets/znfx.png')" class="img" alt="" />
          <span class="col-span-1">智能分析</span>
        </div>
      </div>
      <div class="text">
        <div class="t1">服务海量伙伴的行业案例</div>
        <div class="t2">完善的服务体系为企业数字化上云保驾护航</div>
      </div>
      <div class="client-righ">
        <div class="righ-text">
          <div class="text1">12年+</div>
          <div class="btn1">技术积累</div>
        </div>
        <div class="righ-text">
          <div class="text1">50+</div>
          <div class="btn1">覆盖行业</div>
        </div>
        <div class="righ-text">
          <div class="text1">20W+</div>
          <div class="btn1">用户体量</div>
        </div>
      </div>
      <div class="img-box">
        <img class="img" v-lazy="require('@/assets/dq.png')" alt="" />
      </div>
    </div>
    <div class="enterprise">
      <div class="text">先进的企业选择</div>
      <div class="img-box">
        <div class="img-liet-box">
          <div
            class="img-item"
            v-for="item of enterprise1imgList"
            :key="item.url1"
          >
            <img :src="item.url1" class="img" alt="" />
          </div>
        </div>
        <div class="img-liet-box">
          <div
            class="img-item"
            v-for="item of enterprise2imgList"
            :key="item.url1"
          >
            <img :src="item.url1" class="img" alt="" />
          </div>
        </div>
        <div class="img-liet-box">
          <div
            class="img-item"
            v-for="item of enterprise3imgList"
            :key="item.url1"
          >
            <img :src="item.url1" class="img" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="app-list">
      <div class="text">
        <div class="t1">轻松上手 闭环产品线</div>
        <div class="t2">12年+的技术沉淀，为用户提供快速稳定、</div>
        <div class="t2">智能可靠的服务和产品</div>
      </div>
      <div class="app-box">
        <div class="app-item">
          <div class="title">SaaS收银</div>
          <div class="txt">SaaS化解决方案，一键安装，</div>
          <div class="txt">无需培训，快速上手</div>
          <div class="features-list">
            <div class="features" v-for="item of featuresList1" :key="item">
              {{ item }}
            </div>
          </div>
        </div>
        <div class="app-item">
          <div class="title">智慧零售</div>
          <div class="txt">
            以数字化为驱动力，实现线上线下一体化，企业再次赋能升级
          </div>
          <div class="features-list">
            <div class="features" v-for="item of featuresList2" :key="item">
              {{ item }}
            </div>
          </div>
        </div>
        <div class="app-item">
          <div class="title">订货平台</div>
          <div class="txt">企业供应链数据化管理，B2B数智化管理</div>
          <div class="features-list">
            <div class="features" v-for="item of featuresList3" :key="item">
              {{ item }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="Program">
      <div class="text">
        <div class="t1">丰富的解决方案</div>
        <div class="t2">满足各行业需求，快速实现数字化转型</div>
      </div>
      <div class="Program-item-box">
        <div class="Program-item-list">
          <div
            class="Program-item"
            v-for="item of programList1"
            :key="item.tabel"
          >
            <div class="img-box">
              <img :src="item.url" class="img" alt="" />
            </div>
            <div class="txt">{{ item.tabel }}</div>
          </div>
        </div>
        <div class="Program-item-list Program-item-list1">
          <div
            class="Program-item"
            v-for="item of programList2"
            :key="item.tabel"
          >
            <div class="img-box">
              <img :src="item.url" class="img" alt="" />
            </div>
            <div class="txt">{{ item.tabel }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="ecology-box">
      <div class="text">
        <div class="t1">智能商业服务生态</div>
        <div class="t2">对接众多第三方，提供多方面的优质服务</div>
      </div>
      <div class="swoper-box">
        <swiper :options="ecologyOption" ref="ecologyOption">
          <swiper-slide v-for="item of serveList" :key="item.id">
            <div class="lb">
              <div class="img-title">
                <img :src="item.img" class="img" alt="" />
                <div class="title">{{ item.title }}</div>
              </div>
              <div class="xian"></div>
              <div class="t-box">
                <div class="p-txt">{{ item.p1 }}</div>
                <div class="p-txt">{{ item.p2 }}</div>
                <div class="p-txt">{{ item.p3 }}</div>
                <div class="p-txt">{{ item.p4 }}</div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="ecology-text-box">
        <div class="title">
          {{ serveList[currentIndex].title }}
        </div>
        <div class="txt-box">
          <div class="txt txt1">
            {{ serveList[currentIndex].p5 }}
          </div>
          <div class="txt">{{ serveList[currentIndex].p6 }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "indexH5",
  data() {
    return {
      swiperOption: {
        loop: true,
        // loopAdditionalSlides: 6,
        autoplay: {
          delay: 5000,
          // stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
      },
      currentIndex: 0,
      ecologyOption: {
        // loop: true,
        slidesPerView: 2,
        loopAdditionalSlides: 2,
        spaceBetween: 30,
        centeredSlides: true,
        autoplay: false,
        // autoplay: {
        //   delay: 5000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: true,
        // },
        // 显示分页
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true, //允许分页点击跳转
        // },
      },
      enterprise1imgList: [
        { url1: require("@/assets/yhjh5.png") },
        { url1: require("@/assets/alzmh5.png") },
        { url1: require("@/assets/hklh5.png") },
        { url1: require("@/assets/xmh5.png") },
        { url1: require("@/assets/msh5.png") },
        { url1: require("@/assets/pgyh5.png") },
      ],
      enterprise2imgList: [
        { url1: require("@/assets/yjplh5.png") },
        { url1: require("@/assets/qchh5.png") },
        { url1: require("@/assets/klwmh5.png") },
        { url1: require("@/assets/wsth5.png") },
        { url1: require("@/assets/hfh5.png") },
        { url1: require("@/assets/xh5.png") },
      ],
      enterprise3imgList: [
        { url1: require("@/assets/xjch5.png") },
        { url1: require("@/assets/mxyyh5.png") },
        { url1: require("@/assets/ymh5.png") },
        { url1: require("@/assets/mjqh5.png") },
        { url1: require("@/assets/mshh5.png") },
        { url1: require("@/assets/xfzmh5.png") },
      ],
      featuresList1: [
        "一体化营销",
        "开发式API对接",
        "云端同步",
        "硬件兼容",
        "多终端覆盖",
      ],
      featuresList2: ["特色营销", "店铺装修", "个性化配置", "智能组件"],
      featuresList3: ["高效管理", "数据安全", "资源生态化", "智能分析"],
      programList1: [
        {
          tabel: "便利商超",
          url: require("@/assets/plsch5.png"),
        },
        {
          tabel: "餐饮美食",
          url: require("@/assets/cymsh5.png"),
        },
        {
          tabel: "母婴亲子",
          url: require("@/assets/myqzh5.png"),
        },
        {
          tabel: "精品文具",
          url: require("@/assets/jpwjh5.png"),
        },
      ],
      programList2: [
        {
          tabel: "生鲜蔬菜",
          url: require("@/assets/sysch5.png"),
        },
        {
          tabel: "服饰鞋包",
          url: require("@/assets/fsjbh5.png"),
        },
        {
          tabel: "社区团购",
          url: require("@/assets/sqtgh5.png"),
        },
        {
          tabel: "宠物管理",
          url: require("@/assets/cwglh5.png"),
        },
      ],
      serveList: [
        {
          id: 1,
          img: require("@/assets/fwsc.png"),
          title: "服务市场",
          p1: "市场营销",
          p2: "店铺管理",
          p3: "硬件设备",
          p4: "装修模板",
          p5: "服务市场是基于对官方能力的补充和丰富，为满足商家多元化需求而打造的全场景一站式服务选购平台，",
          p6: " 严选7大经营场景：市场营销、店铺管理、硬件设备、装修模板、运营管理、定制服务、企业服务，涵盖各类商家都在用的经营工具和服务。",
        },
        {
          id: 2,
          img: require("@/assets/dzkf.png"),
          title: "定制开发",
          p1: "服务号定制",
          p2: "企业号定制",
          p3: "小程序定制",
          p4: "个性化行业定制",
          p5: "以互联网定制开发为主营业务，专注微信服务号、企业号、微信公众平台开发和微信小程序等的微信开发服务。凭借专业的研发团队，在微信商城、会员、分销、营销等领域具有丰富的开发经验，全方位满足企业个性化需求，已为众多品牌提供专业定制开发服务。",
        },
        {
          id: 3,
          img: require("@/assets/jjfa.png"),
          title: "解决方案",
          p1: "小程序",
          p2: "大数据BI",
          p3: "云支付",
          p4: "第三方对接",
          p5: "服务市场是基于对官方能力的补充和丰富，为满足商家多元化需求而打造的全场景一站式服务选购平台。",
          p6: "  严选7大经营场景：市场营销、店铺管理、硬件设备、装修模板、运营管理、定制服务、企业服务，涵盖各类商家都在用的经营工具和服务。",
        },
        {
          id: 4,
          img: require("@/assets/zsfw.png"),
          title: "专属服务",
          p1: "7×24小时服务",
          p2: "1v1大客户服务",
          p3: "运维服务",
          p4: "无忧退款",
          p5: "服务市场是基于对官方能力的补充和丰富，为满足商家多元化需求而打造的全场景一站式服务选购平台。",
          p6: "  严选7大经营场景：市场营销、店铺管理、硬件设备、装修模板、运营管理、定制服务、企业服务，涵盖各类商家都在用的经营工具和服务。",
        },
      ],
    };
  },
  computed: {
    swiper() {
      return this.$refs.ecologyOption.$swiper;
    },
  },
  mounted() {
    this.swiper.on("slideChangeTransitionEnd", () => {
      this.currentIndex = this.swiper.activeIndex;
    });
  },
  activated() {
    this.$refs.contH5.scrollIntoView();
  },
};
</script>

<style lang="less" scoped>
.cont-h5 {
  width: 750px;
  overflow-x: hidden;
  .swoper-box {
    /deep/ .swiper-pagination-bullet {
      width: 40px;
      height: 8px;
      display: inline-block;
      border-radius: 4px;
      background: #292929;
      opacity: 0.3;
    }
    /deep/.swiper-pagination-bullets {
      bottom: 135px;
      text-align: left;
      left: 50%;
      transform: translateX(-50%);
      width: auto;
    }
    /deep/ .swiper-pagination-bullet-active {
      background: #336fff;
      opacity: 1;
    }
    .lb {
      width: 750px;
      height: 720px;
      .text {
        text-align: center;
        padding-top: 60px;
        .t1 {
          font-weight: 700;
          font-size: 52px;
          line-height: 75px;
          color: #1a1a1a;
          margin-bottom: 12px;
        }
        .t2 {
          font-size: 28px;
          line-height: 36px;
          color: #6c727b;
          text-align: center;
        }
      }
    }
    .lb1 {
      background: url("~@/assets/h5lbt1.png") no-repeat;
      background-size: 100% 100%;
    }
    .lb2 {
      background: url("~@/assets/h5lbt2.png") no-repeat;
      background-size: 100% 100%;
    }
    .lb3 {
      background: url("~@/assets/h5lbt3.png") no-repeat;
      background-size: 100% 100%;
    }
    .lb4 {
      background: url("~@/assets/h5lbt4.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  .case-box {
    width: 750px;
    height: 560px;
    position: relative;
    padding-top: 100px;
    .title-box {
      width: 696px;
      position: absolute;
      left: 27px;
      top: -100px;
      display: flex;
      z-index: 2;
      align-items: center;
      justify-content: space-between;
      .title-iteme {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 224px;
        height: 132px;
        background: linear-gradient(180deg, #eef1ff 0%, #ffffff 100%);
        border: 4px solid #ffffff;
        box-shadow: 8px 16px 20px rgba(112, 163, 245, 0.08);
        border-radius: 8px;
        .img {
          width: 56px;
          height: 56px;
        }
        .col-span-1 {
          font-size: 28px;
          line-height: 36px;
          color: #292929;
        }
      }
    }
    .text {
      text-align: center;
      margin-bottom: 32px;
      .t1 {
        font-size: 40px;
        line-height: 48px;
        font-weight: 500;
        color: #292929;
      }
      .t2 {
        margin-top: 20px;
        font-size: 28px;
        line-height: 40px;
        color: #3d485d;
      }
    }
    @keyframes loading {
      0% {
        transform: rotate(0deg);
      }

      100% {
        transform: rotate(360deg);
      }
    }
    .img-box {
      width: 750px;
      position: absolute;
      z-index: -1;
      left: 50%;
      transform: translateX(-50%);
      .img {
        animation: loading 60s infinite linear;
        width: 750px;
        height: 750px;
      }
    }
    .client-righ {
      position: absolute;
      left: 119px;
      width: 512px;
      height: 108px;
      bottom: 100px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .righ-text {
        width: 114px;
        height: 108px;
        .text1 {
          font-weight: 700;
          font-size: 37px;
          line-height: 40px;
          color: #3d485d;
          margin-bottom: 8px;
        }
        .btn1 {
          width: 144px;
          height: 60px;
          border: 2px solid #798496;
          border-radius: 2px;
          text-align: center;
          line-height: 60px;
          font-size: 26px;
          color: #3d485d;
        }
      }
    }
  }
  .enterprise {
    width: 750px;
    height: 540px;
    padding: 64px 32px;
    overflow: hidden;
    background: #ffffff;
    .text {
      text-align: center;
      line-height: 48px;
      color: #292929;
      font-size: 36px;
      font-weight: 500;
    }
    .img-box {
      width: 686px;
      overflow-x: auto;
      margin-top: 40px;
    }
    .img-liet-box {
      width: 1404px;
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      margin-bottom: 8px;
      .img-item {
        width: 224px;
        height: 100px;
        background: #ffffff;
        box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
        border-radius: 12px;
        .img {
          width: 224px;
          height: 100px;
        }
      }
    }
  }
  .app-list {
    background: #f8f9fb;
    padding: 80px 32px;
    .text {
      text-align: center;
      .t1 {
        font-size: 40px;
        font-weight: 500px;
        color: #292929;
        margin-bottom: 20px;
      }
      .t2 {
        font-size: 28px;
        line-height: 40px;
        color: #3d485d;
      }
    }
    .app-box {
      margin-top: 40px;
      width: 686px;
      height: 1314px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      .app-item {
        width: 686px;
        background: url("~@/assets/bg.png") no-repeat;
        background-size: 100% 100%;
        padding: 32px;
        filter: drop-shadow(8px 8px 20px rgba(55, 99, 170, 0.1));
        border-radius: 8px;
        .title {
          font-size: 40px;
          font-weight: 500;
          line-height: 56px;
          color: #336fff;
          margin-bottom: 10px;
        }
        .txt {
          font-size: 28px;
          color: #3d485d;
          line-height: 40px;
        }
        .features-list {
          margin-top: 32px;
          display: flex;
          flex-wrap: wrap;
          .features {
            background: #ffffff;
            box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
            border-radius: 4px;
            padding: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 28px;
            line-height: 36px;
            margin-right: 16px;
            margin-bottom: 16px;
            color: #3d485d;
          }
        }
      }
    }
  }
  .Program {
    padding: 64px 32px;
    overflow: hidden;
    .text {
      text-align: center;
      margin-bottom: 40px;
      .t1 {
        font-size: 40px;
        font-weight: 500px;
        color: #292929;
        margin-bottom: 20px;
      }
      .t2 {
        font-size: 28px;
        line-height: 40px;
        color: #3d485d;
      }
    }
    .Program-item-box {
      width: 686px;
      overflow-x: auto;
      .Program-item-list {
        width: 1402px;
        padding-right: 32px;
        display: flex;
        align-content: center;
        justify-content: space-between;
        height: 288px;
        .Program-item {
          width: 320px;
          height: 288px;
          background: #ffffff;
          border: 4px solid #ffffff;
          box-shadow: 4px 4px 16px rgba(55, 99, 170, 0.1);
          border-radius: 6px;
          overflow: hidden;
          .img-box {
            width: 320px;
            height: 200px;
            .img {
              width: 320px;
              height: 200px;
            }
          }
          .txt {
            width: 320px;
            height: 88px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 30px;
            color: #353535;
          }
        }
      }
      .Program-item-list1 {
        margin-top: 40px;
      }
    }
  }
  .ecology-box {
    padding: 40px 32px;
    background: #ffffff;
    .text {
      text-align: center;
      margin-bottom: 40px;
      .t1 {
        font-size: 40px;
        font-weight: 500px;
        color: #292929;
        margin-bottom: 20px;
      }
      .t2 {
        font-size: 28px;
        line-height: 40px;
        color: #3d485d;
      }
    }
    .swoper-box {
      .swiper-slide {
        background: linear-gradient(180deg, #f0f2f5 0%, #ffffff 100%);
      }
      .swiper-slide-active,
      .swiper-slide-duplicate-active {
        background: #ffffff;
      }
      .lb {
        width: 360px;
        height: 436px;
        border: 4px solid #ffffff;
        box-shadow: 0px 4px 16px rgba(139, 159, 191, 0.2);
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .img-title {
          width: 144px;
          height: 118px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          .img {
            width: 64px;
            height: 64px;
          }
          .title {
            font-weight: 500;
            font-size: 36px;
            line-height: 48px;
            text-align: center;
            color: #336fff;
          }
        }
        .xian {
          width: 68px;
          height: 0px;
          border: 0.5px solid #292929;
          margin: 24px 0;
        }
        .t-box {
          .p-txt {
            font-size: 26px;
            line-height: 40px;
            text-align: center;
            color: #3d485d;
            margin-bottom: 10px;
          }
          .p-txt:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
    .ecology-text-box {
      margin-top: 16px;
      width: 686px;
      height: 368px;
      background: #f5f7fa;
      border-radius: 6px;
      padding: 20px;
      .title {
        font-weight: 500;
        font-size: 30px;
        line-height: 48px;
        color: #336fff;
        margin-bottom: 20px;
      }
      .txt-box {
        border-top: 1px solid #333333;
        padding-top: 20px;
        .txt {
          font-size: 26px;
          line-height: 40px;
          color: #292929;
        }
        .txt1 {
          margin-bottom: 40px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/h5/index.vue